var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.AllowedDisplay)?_c('not-allowed',{attrs:{"page":_vm.page,"module":_vm.idmodule,"data":_vm.datas}}):_vm._e(),_c('v-scale-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }